import { customerApi } from "../../utils/apiConfig";

export const getCustomers = () => {
  return customerApi.post(
    "/getCustomer",
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const getCustomerDetail = (formId) => {
  return customerApi.post(
    `/getCustomerDetail/${formId}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const insertCustomer = (customerData) => {
  return customerApi.post("/insertCustomer", customerData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const addCustomerNote = (noteData) => {
  return customerApi.post("/addCustomerNote", noteData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateCustomerNote = (noteData) => {
  return customerApi.post("/updateCustomerNote/" + noteData.id, noteData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteCustomerNote = (payload) => {
  return customerApi.post("/deleteCustomerNote/" + payload.id, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const downloadCustomerDocument = async (payload) => {
  return customerApi.post("/downloadCustomerDocument", payload, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const addCustomerQualityRequirement = (qualityData) => {
  return customerApi.post("/addCustomerQualityRequirement", qualityData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateCustomerQualityRequirement = (qualityData) => {
  return customerApi.post(
    "/updateCustomerQualityRequirement/" + qualityData.id,
    qualityData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const deleteCustomerQualityRequirement = (payload) => {
  return customerApi.post(
    "/deleteCustomerQualityRequirement/" + payload.id,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const uploadCustomerDocument = (formData) => {
  return customerApi.post("/uploadCustomerDocument", formData, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateCustomerDocument = (formData) => {
  return customerApi.post("/updateCustomerDocument", formData, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteCustomerDocument = (payload) => {
  return customerApi.post("/deleteCustomerDocument", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteCustomer = (id) => {
  return customerApi.post(
    "/deleteCustomer",
    { id },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const updateCustomer = (customerData) => {
  return customerApi.post("/updateCustomer", customerData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
